import InnovationProcess from './innovationProcess/InnovationProcess'
import styles from './InnovationSubhead.module.scss'
import { Flex } from '../common/flex/Flex'
import { Typography } from '../common/Typography/Typography'

const title = 'Dive into the Innovation Process'
const sectionContent = [
  {
    title: 'Strategy to Idea',
    titleColor: '#4C007D',
    backgroundColor: 'linear-gradient(0deg, rgba(73, 109, 253, 0.3) 0%, #FFFFFF 86.89%)',
  },
  {
    title: 'Idea to Bank',
    titleColor: '#5D1810',
    backgroundColor: 'linear-gradient(0deg, rgba(170, 53, 39, 0.4) -14.55%, #FFFFFF 90.2%)',
  },
  {
    title: 'Bank to Shelf',
    titleColor: '#AA3527',
    backgroundColor: 'linear-gradient(0deg,rgba(252, 77, 15, 0.2) -7.2%, #FFFFFF 91.5%)',
  },
  {
    title: 'Shelf to Retirement',
    titleColor: '#9F4200',
    backgroundColor: 'linear-gradient(0deg, #FEDEA8 0%, #FFFFFF 86.89%)',
  },
]

const InnovationSubhead = () => {
  return (
    <Flex direction="column" gap={53} className={styles.container}>
      <div className={styles.titleContainer}>
        <h2 className={styles.title}>{title}</h2>
      </div>
      <Flex gap={9} direction="row" className={styles.innovationContainer}>
        {sectionContent.map(sectionItem => (
          <div
            key={sectionItem.title}
            className={styles.innovationProcessSection}
            style={{ background: sectionItem.backgroundColor }}
          >
            <Flex gap={9}>
              <div className={styles.beforeTitle} style={{ backgroundColor: sectionItem.titleColor }} />
              <Typography
                type="xl-heading"
                tag="p"
                className={styles.sectionTitle}
                style={{ color: sectionItem.titleColor }}
              >
                {sectionItem.title}
              </Typography>
            </Flex>
          </div>
        ))}
        <InnovationProcess />
      </Flex>
    </Flex>
  )
}

export default InnovationSubhead
